import { NzModalService } from 'ng-zorro-antd/modal';
import { AppComponent } from './app.component';
import { registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import en from '@angular/common/locales/en';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { RebirthHttpProvider } from 'rebirth-http';
import { AppRoutingModule } from './app-routing.module';
import { LayoutModule } from './layout/layout.module';
import { AppExceptionHandlingService } from './layout/services/app-exception-handling.service';

import { BaseSharedState } from './shared-resources/store/base.state';
import { NgxsModule } from '@ngxs/store';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AppConfig } from './layout/services/app-config.service';
import { ALAIN_I18N_TOKEN, ALAIN_SETTING_KEYS } from '@delon/theme';
import { I18NService } from './shared-resources/base-i18n/services/i18n.service';
import { AlainConfigService } from '@delon/util';
import { ACLService, DelonACLModule } from '@delon/acl';
import { BaseSharedModule } from 'base-shared';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NzMessageService } from 'ng-zorro-antd/message';
import { GoogleMapsModule } from '@angular/google-maps';
import { SharedModule } from './shared-resources/shared.module';
import { DefaultErrorInterceptor } from './shared-resources/interceptors/default-error.interceptor';
import { AuthInterceptor } from './shared-resources/interceptors/auth.interceptor';
import { ClmState } from './shared-resources/store/clm.state';

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}
const I18NSERVICE_PROVIDES = [
  { provide: ALAIN_I18N_TOKEN, useClass: I18NService, multi: false },
];

registerLocaleData(en);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    GoogleMapsModule,
    BaseSharedModule,
    // RebirthHttpModule, // Not compatible with Angular 18
    NgxsModule.forRoot(),
    NgxsModule.forFeature([BaseSharedState, ClmState]),
    DelonACLModule,
    NgxsReduxDevtoolsPluginModule.forRoot(),
    NgxsLoggerPluginModule.forRoot(),
    TranslateModule.forRoot(),
    AppRoutingModule,
    LayoutModule,
    SharedModule
  ],
  exports: [],
  providers: [
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig],
      multi: true,
    },
    {
      provide: ALAIN_SETTING_KEYS,
      useValue: {
        layout: 'layout',
        user: 'user',
        app: 'app',
      },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DefaultErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    AppExceptionHandlingService,
    {
      provide: ErrorHandler,
      useClass: AppExceptionHandlingService,
    },
    { provide: NZ_I18N, useValue: en_US },
    ...I18NSERVICE_PROVIDES,
    RebirthHttpProvider,
    AlainConfigService,
    NzNotificationService,
    ACLService,
    NzModalService,
    NzMessageService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
